
export default {
  props: {
    isDark: { type: Boolean, default: false },
    language: { type: String, required: true },
  },
}
